/**
 * 独自の入力チェック規則は、値を文字列にしてから調べる。
 *
 * 画面を開いたときにサーバから数値で入った値（予定超過残業の申請の修正で、
 * 予定時間外勤務時間が 2 のように数値で返る）を value.match で読むと
 * TypeError になり、入力チェックごと止まる。送信ボタンを押したときに
 * 入力チェックするので、止まると「押しても送られない」になる
 * （2026-09-17、修正画面で実際に踏んだ）。
 */
export default function asTextRule (rule) {
  return {
    ...rule,
    validate: (value, params) => rule.validate(value == null ? '' : String(value), params)
  }
}
